import ClinicReport from "../ClinicReport/ClinicReport";

const ChainReport = ({report, isStandalone}) => {
    return (
        <ClinicReport isStandalone={isStandalone} report={report} isChain={true} />
    )
}

export default ChainReport;